(function () {
  const MOBILE_QUERY = '(max-width: 767px)';

  function initTrustpilotSlider(root) {
    if (!root || root.dataset.trustpilotInitialized === 'true') return;

    const track = root.querySelector('[data-trustpilot-track]');
    const nav = root.querySelector('[data-trustpilot-nav]');
    const prevBtn = root.querySelector('[data-trustpilot-prev]');
    const nextBtn = root.querySelector('[data-trustpilot-next]');
    const slides = root.querySelectorAll('[data-trustpilot-slide]');

    if (!track || !nav || !prevBtn || !nextBtn || slides.length === 0) return;

    root.dataset.trustpilotInitialized = 'true';

    let scrollTimeout;

    function isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    function getSlideOffset() {
      const firstSlide = slides[0];
      if (!firstSlide) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstSlide.offsetWidth + gap;
    }

    function getNearestIndex() {
      const offset = getSlideOffset();
      if (!offset) return 0;
      return Math.round(track.scrollLeft / offset);
    }

    function updateButtons() {
      if (!isMobile()) {
        return;
      }

      const maxScroll = track.scrollWidth - track.clientWidth;
      const index = getNearestIndex();

      prevBtn.disabled = index <= 0 && track.scrollLeft <= 1;
      nextBtn.disabled = index >= slides.length - 1 && track.scrollLeft >= maxScroll - 1;
    }

    function scrollToIndex(index) {
      const clamped = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: clamped * getSlideOffset(),
        behavior: 'smooth',
      });
    }

    function onPrev() {
      scrollToIndex(getNearestIndex() - 1);
    }

    function onNext() {
      scrollToIndex(getNearestIndex() + 1);
    }

    function onScroll() {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(updateButtons, 80);
      updateButtons();
    }

    function onKeydown(event) {
      if (!isMobile()) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        onPrev();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        onNext();
      }
    }

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('keydown', onKeydown);

    const resizeObserver = new ResizeObserver(updateButtons);
    resizeObserver.observe(track);
    slides.forEach((slide) => resizeObserver.observe(slide));

    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    mediaQuery.addEventListener('change', updateButtons);
    updateButtons();
  }

  function boot() {
    document.querySelectorAll('[data-trustpilot-slider]').forEach(initTrustpilotSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const slider = event.target.querySelector('[data-trustpilot-slider]');
    if (slider) initTrustpilotSlider(slider);
  });
})();
